import { createFileRoute } from '@tanstack/react-router';
import Logout from '@src/pages/Auth/Logout';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/auth/logout')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('logout.page_title', 'Logout') }],
  }),
  component: Logout,
});
